import { Tooltip } from '@material-ui/core';

import { RiChat1Line } from '@remixicon/react';

import { ButtonIcon } from '@backstage/ui';

import {
  useCommentState,
  useCommentZone,
  useOpenCommentsForZone,
} from '@spotify/plugin-confidence-comments-react';

export const BlockCommentButton = () => {
  const zone = useCommentZone();
  const comment = useCommentState(state => state.comment);
  const selectComment = useCommentState(state => state.selectComment);
  const comments = useOpenCommentsForZone(zone);
  const commentCount = comments.length;

  const handleClick = () => {
    if (commentCount > 0) {
      selectComment(comments[0].name, { zone });
    } else {
      comment({ zone });
    }
  };

  return (
    <Tooltip
      title={
        commentCount > 0
          ? `${commentCount} comment${commentCount > 1 ? 's' : ''}`
          : 'Add comment'
      }
    >
      <ButtonIcon
        aria-label={commentCount > 0 ? 'View comments' : 'Add comment'}
        onClick={handleClick}
        size="small"
        icon={<RiChat1Line size={18} />}
        variant={commentCount > 0 ? 'primary' : 'tertiary'}
        data-track-id={
          commentCount > 0 ? 'button.view-comments' : 'button.add-comment'
        }
        data-track-action={commentCount > 0 ? 'navigate' : 'create'}
      />
    </Tooltip>
  );
};
